// entities/defaultFunctions.ts
import { fromNetwork } from "../symbols.js";
import { constructValue } from "./construct.js";
var defaultCompare = (oldValue, newValue, field) => {
  if (field.type() === Date)
    return (oldValue?.getTime() ?? oldValue) === (newValue?.getTime() ?? newValue);
  return oldValue === newValue;
};
var defaultMerge = (localValue, remoteValue, field, entity, isFromNetwork) => {
  if (remoteValue !== void 0) {
    if (remoteValue && typeof remoteValue === "object")
      remoteValue[fromNetwork] = isFromNetwork;
    return constructValue(remoteValue, field);
  }
  return localValue;
};
export {
  defaultCompare,
  defaultMerge
};
